import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Box, Drawer, IconButton, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ProductCatalogCategorySelector from './ProductCatalogCategorySelector';

interface ProductCatalogBrowseDrawerProps {
  open: boolean
  onClose: () => void
}

const browseDrawerPaperSx = {
  width: '100%',
  height: 'auto',
  maxHeight: 'min(78dvh, calc(100dvh - 52px))',
  borderTopLeftRadius: 12,
  borderTopRightRadius: 12,
  backgroundColor: '#f0f0f0',
};

export default function ProductCatalogBrowseDrawer(props: ProductCatalogBrowseDrawerProps) {
  const [t] = useTranslation('products');

  return <Drawer
    anchor="bottom"
    open={props.open}
    onClose={props.onClose}
    ModalProps={{
      keepMounted: true,
      sx: {
        zIndex: 1290,
      },
    }}
    PaperProps={{
      sx: browseDrawerPaperSx,
    }}
  >
    <Stack sx={{ maxHeight: 'inherit' }}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          px: 3,
          py: 2,
          borderBottom: '0.7px solid #afafaf',
        }}
      >
        <Typography variant="h3">{t('Browse products')}</Typography>
        <IconButton
          aria-label={t('Hide Browse')}
          edge="end"
          onClick={props.onClose}
        >
          <CloseRoundedIcon />
        </IconButton>
      </Stack>
      <Box
        component="div"
        sx={{
          overflowY: 'auto',
          px: 3,
          py: 3,
        }}
      >
        <ProductCatalogCategorySelector variant="sheet" onNavigate={props.onClose} />
      </Box>
    </Stack>
  </Drawer>;
}
